module.exports = __webpack_public_path__ + "img/61.b595f486.svg";